export default from './followers-page';



// WEBPACK FOOTER //
// ./app/containers/followers-page/index.js